import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

const SlideOutLogo = ({
  slideOutAmount,
  children,
}: {
  children: React.ReactElement
  slideOutAmount: number
}) => {
  const useStyles = makeStyles(theme => ({
    '@keyframes slideLeft': {
      '0%': { marginLeft: 0 },
      '20%': { marginLeft: 0 },
      '50%': { marginLeft: 0 },
      '100%': { marginLeft: `${slideOutAmount}px` },
    },
    animatedLogo: {
      '& img': {
        marginLeft: `${slideOutAmount}px`,
        marginRight: 0,
        maxWidth: '250px',
        [theme.breakpoints.up('sm')]: {
          animation: '$slideLeft 4s forwards',
          marginLeft: 'inherit',
        },
      },
    },
  }))
  const classes = useStyles()

  return <div className={classes.animatedLogo}>{children}</div>
}

export default SlideOutLogo
